module.exports = __webpack_public_path__ + "f595c3e69e6a439838da14f8d93c4774.glb";